@if (component.data$ | async; as data) {
  <p [innerHTML]="data.content | safeHtml"></p>
}
